import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {environment} from '../environments/environment';
import {CookieService} from 'ngx-cookie-service';

export const ADMIN_COOKIE_TOKEN = 'tools-admin-token';
export const ADMIN_COOKIE_USER_NAME = 'tools-admin-user-name';

export interface IParams {
  module_fn: string;
  [optional: string]: any;
}


@Injectable({
  providedIn: 'root'
})
export class ApiCallService {

  constructor(private http: HttpClient, private cookieService: CookieService) {
  }

  get apiUrl(): string {
    return environment.apiUrl;
  }

  private get httpOptions(): any {
    return {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'x-admin-token': this.adminToken,
        'x-admin-name': this.adminUserName,
        'x-credential-id': 'w613hjahsd623hkjhsd277',
        'x-credential-provider': 'admin-page'
      })
    };
  }


  // dynamic request function base on sever method names
  dynamicCall(params: IParams): Observable<any> {
    const apiUrl = `${environment.apiUrl}/dynamicCall`;
    return this.http.post<any>(apiUrl, params, this.httpOptions);
  }


  get adminToken(): string {
    return this.cookieService.get(ADMIN_COOKIE_TOKEN);
  }

  set adminToken(value: string) {
    const d = new Date();
    d.setDate(d.getDate() + 365);
    this.cookieService.set(ADMIN_COOKIE_TOKEN, value, d, '/');
  }

  get adminUserName(): string {
    return this.cookieService.get(ADMIN_COOKIE_USER_NAME);
  }

  set adminUserName(value: string) {
    const d = new Date();
    d.setDate(d.getDate() + 365);
    this.cookieService.set(ADMIN_COOKIE_USER_NAME, value, d, '/');
  }
}
